import { SeriesOptions } from 'highcharts/highstock';
import { DeviceReadingsResult } from 'types';
import { covReading, sortSeries } from '../general';

export const addCovSeries = (
    series: SeriesOptions[],
    readings: DeviceReadingsResult
) => {
    const covData = [];
    for (const reading of readings.data) {
        if (!reading.hide) {
            if (covReading(reading.sig))
                covData.push([reading.time, reading.tank]);
        }
    }
    const covSeries = {
        id: 'cov',
        type: 'scatter',
        color: '#FF5722',
        yAxis: 0,
        zIndex: 0,
        name: 'cov',
        marker: {
            enabled: true,
            fillColor: '#FFFFFF',
            lineWidth: 2,
            lineColor: null,
            radius: 4,
            symbol: 'diamond',
        },
        tooltip: {
            valueDecimals: 1,
            headerFormat:
                '<span style="font-size: 10px">{point.x:%b %e %l:%M %p}</span>',
            pointFormat:
                '<br><span style="color:{series.color}">\u25CF</span> Cov <br> Tank: {point.y}',
        },
        dataGrouping: { enabled: false },
        data: sortSeries(covData),
    };
    series.push(covSeries);
};
